import { GetRequiredExpertDetailsForHcsResponseIds } from '@toktokdoctech/tokapi-client'
import { UserData } from '../_props'
import { makePointer } from '../../../api/_utils'

export const computeData = (userId: string, requiredExpert: GetRequiredExpertDetailsForHcsResponseIds): UserData => {
    const profession = requiredExpert?.professions?.length ? requiredExpert.professions[0] : { id: '', name: '' }

    return {
        objectId: userId,
        firstName: requiredExpert.firstName,
        lastName: requiredExpert.lastName,
        civility: requiredExpert.civility,
        title: requiredExpert.title ?? '',
        rpps: requiredExpert.rppsNum ?? undefined,
        validRpps: !!requiredExpert.rppsNum,
        category: requiredExpert.category ?? '',
        profession: profession.name,
        professionId: profession.id,
        professionPointer: makePointer('Profession', profession.id),
        qualification: requiredExpert.qualification?.name ?? '',
        qualificationId: requiredExpert.qualification?.id,
        qualificationPointer: makePointer('Qualification', requiredExpert.qualification?.id ?? ''),
        speciality: requiredExpert.speciality?.name,
        specialityId: requiredExpert.speciality?.id,
        specialityPointer: makePointer('Speciality', requiredExpert.speciality?.id ?? ''),
        idnps: requiredExpert.nationalId || undefined,
        securedEmail: requiredExpert.securedEmail,
        email: '',
        initialEmail: '',
        contactPhone: '',
        speMentions: [],
        role: undefined,
    }
}
